import React, {Component} from 'react';

class RedirectLink extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        window.scrollTo(0, 0);
        if(window.location.hostname.indexOf("propertybooster") !== -1){
            this.props.history.push("/ae/en");
        }else if(window.location.hostname.indexOf("boostabostad") !== -1){
            this.props.history.push("/se/sv");
        }else if(window.location.hostname.indexOf("yieldlock") !== -1){
            this.props.history.push("/ae/en");
        }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
            this.props.history.push("/ae/en");
        }else{
            this.props.history.push("/ae/en");
        }

        //test
    }

    render() {
        return (
            <div></div>
        )
    }

}

export default RedirectLink


// WEBPACK FOOTER //
// ./src/components/redirect/component.js